import { FuelOfferTabs } from '../../../../routes/_app.fuel.offers';
import { FuelOfferSortOption } from '../FuelOfferOverviewSortSelect';

export const selectSortOption = (tab: FuelOfferTabs): FuelOfferSortOption['value'] => {
    switch (tab) {
        case 'enquired': {
            return {
                sortField: 'validUntil',
                sortDirection: 'ASC',
            };
        }
        case 'offered': {
            return {
                sortField: 'quoteValidUntil',
                sortDirection: 'ASC',
            };
        }
        default: {
            return {
                sortField: 'dateUpdated',
                sortDirection: 'DESC',
            };
        }
    }
};
